import React, { useState, useRef } from "react";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import Icons from '../../icons';
import { uploadFileOnPublicApiV2 } from '@common/util';
import LoaderComponent from "../../../app/components/Loader/index";

import "react-image-crop/dist/ReactCrop.css";

const ASPECT_RATIO = 1;
const MIN_CROP_SIZE = 0;

const centerAspectCrop = (mediaWidth, mediaHeight, aspect) => {
    return centerCrop(
        makeAspectCrop(
            { unit: "%", width: 25 },
            aspect,
            mediaWidth,
            mediaHeight
        ),
        mediaWidth,
        mediaHeight
    );
};

const getCroppedImageBlob = (image, crop) => {    
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        canvas.width,
        canvas.height
    );
 
    return new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), "image/jpeg");
    });
};

const ImageCropper = (props) => {
    const [imgSrc, setImgSrc] = useState(null);
    const [crop, setCrop] = useState();
    const [fileName, setFileName] = useState();
    const [completedCrop, setCompletedCrop] = useState(null);
    const [isLoaderVisible, setIsLoaderVisible] = useState(false);

    const imgRef = useRef(null);

    const onSelectFile = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        setFileName(file.name);
        reader.addEventListener("load", () => setImgSrc(reader.result));
        reader.readAsDataURL(file);
    };

    const onImageLoad = (e) => {
        const { width, height } = e.currentTarget;
        setCrop(centerAspectCrop(width, height, ASPECT_RATIO));
    };

    const onUpload = async () => {
        if (!completedCrop || !imgRef.current) return;
        setIsLoaderVisible(true)
        const blob = await getCroppedImageBlob(imgRef.current, completedCrop);
        const formData = new FormData();
        formData.append("file", blob, fileName);
        formData.append('type', 'user');
        const response =  await uploadFileOnPublicApiV2(formData, props.moduleType);
        const result = response.data.result[0];
        if(result){
            setIsLoaderVisible(false);
            props.onSuccess(result);
        }
    };

    const removeImage = () => {
        setImgSrc(null);
        setCrop(undefined);
        setCompletedCrop(null);
    };    

    return (
        <div className={props.wrapperCls}>
            {
                isLoaderVisible ? <LoaderComponent /> : null
            }
            <div className="colFlex uploadProfile">
                <div className="alignMiddle uploadHead rowSpaceBetween">
                    <h1>{props.title}</h1>
                </div>
                <div className="alignMiddle">
                    <div className="browseMask colFlex alignMiddle alignCenter">
                        {imgSrc ? (
                            <>
                                <button  type="button" className="btn-cc btn-cc__link cross" onClick={removeImage}>
                                    <Icons name="close" className="icon" />
                                </button>
                                <ReactCrop
                                    crop={crop}
                                    onChange={(_, percentCrop) => setCrop(percentCrop)}
                                    onComplete={(c) => setCompletedCrop(c)}
                                    aspect={ASPECT_RATIO}
                                    minWidth={MIN_CROP_SIZE}
                                    minHeight={MIN_CROP_SIZE}
                                    circularCrop={true}
                                >
                                    <img
                                        ref={imgRef}
                                        src={imgSrc}
                                        alt="Crop preview"
                                        onLoad={onImageLoad}
                                        style={{ maxHeight: 500, maxWidth: 500 }}
                                    />
                                </ReactCrop>
                            </>
                        ) : (
                            <>
                                <span className="fileUpload">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={onSelectFile}
                                        title=""
                                        name="fileName"
                                        multiple={false}
                                        className="fileupload"
                                    />
                                    <a className="pointer">Browse</a> an image from your computer
                                </span>
                                <p>We recommend an image size of 500 x 500 pixels.</p>
                            </>
                        )}
                    </div>
                </div>
                <div className="rowFlex alignRight alignMiddle">
                    <button
                        className={`btn buttonGradient ${!completedCrop ? "disabled" : ""}`}
                        disabled={!completedCrop}
                        type="submit"
                        onClick={onUpload}
                    >
                        {props.uploadText}
                    </button>

                    <button className="btn link" type="button" onClick={props.onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImageCropper;
